"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _pageSwitch = _interopRequireDefault(require("../styles/page-switch.css"));

var _pageSwitch2 = _interopRequireDefault(require("./page-switch.props/page-switch.propTypes"));

var TabButton = function TabButton(_ref) {
  var tab = _ref.tab,
      index = _ref.index,
      selectedIndex = _ref.selectedIndex,
      updateSelectedIndex = _ref.updateSelectedIndex,
      checkSelectedTab = _ref.checkSelectedTab,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: theme.inputsAndOptions + " " + _pageSwitch["default"].tabButton + " " + (checkSelectedTab(selectedIndex, index) ? _pageSwitch["default"].selected : ''),
    onClick: function onClick() {
      return updateSelectedIndex(index);
    }
  }, tab.label);
};

var _default = TabButton;
exports["default"] = _default;